/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentEditMultipleViewModel } from "../types/IndividualPaymentEditMultipleViewModel.ts";

export const individualPaymentEditMultipleViewModelSchema = z.object({
  parcelsId: z.array(z.number().int()).nullish(),
  total: z.number().nullish(),
  discountPunctualPercentage: z.number().nullish(),
  retroactiveDiscount: z.number().nullish(),
  totalDiscount: z.number().nullish(),
  fine: z.number().nullish(),
  message: z.string().nullish(),
  expirationDate: z.string().datetime().nullish(),
  fixDueDate: z.optional(z.boolean()),
}) as unknown as ToZod<IndividualPaymentEditMultipleViewModel>;
